<app-header></app-header>
<div class="container-fluid" [style.font-family]="'var(--vex-font)'">
  <div class="flex justify-center min-h-screen bg-gradient-to-b   rounded subheading-2" style="
      background: linear-gradient(
        180deg,
        #5C9DFE 0%,
        #5C9DFE 39.94%,
        #8BC9F9 113.79%
      );
    " *ngIf="status">
    <div class="flex-1 flex items-center justify-center " style="
        background: linear-gradient(
          180deg,
          rgba(0, 0, 0, 0.28) 0%,
          rgba(0, 0, 0, 0) 100%
        );
      ">
      <div class="container  flex flex-col md:flex-row p-6">
        <div class="md:w-1/2 md:mt-8">
          <img src="assets/images/register-org/register.svg" alt="Register">
        </div>
        <div class="md:w-1/2 p-2 md:p-6 mt--30px">
          <mat-card class="shadow w-full p-4 md:p-6">
            <mat-card-content>
              <h2 class="text-2xl font-semibold mb--10px">

                Your Solution for Smooth Admissions Awaits — Sign Up for Free !
              </h2>
              <form [formGroup]="registerForm" class="mt-15px">
                <mat-form-field appearance="outline" class="w-full">
                  <mat-label [style.font-family]="'var(--vex-font)'">Organisation Name</mat-label>
                  <input matInput placeholder="Enter Your Organisation Name" formControlName="organisation_name"
                         (keyup)="registerFormStatus()" [style.font-family]="'var(--vex-font)'">
                </mat-form-field>
                <div class="flex flex-col sm:flex-row sm:gap-4">
                  <mat-form-field appearance="outline" class="flex-auto">
                    <mat-label [style.font-family]="'var(--vex-font)'">Name</mat-label>
                    <input matInput placeholder="Contact Person's Name" formControlName="name"
                           (keyup)="registerFormStatus()"
                           [style.font-family]="'var(--vex-font)'">
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="flex-auto">
                    <mat-label [style.font-family]="'var(--vex-font)'">Email</mat-label>
                    <input matInput type="email" placeholder="Contact Person's Email" formControlName="email"
                           (keyup)="registerFormStatus()" [style.font-family]="'var(--vex-font)'">
                  </mat-form-field>
                </div>
                <div class="flex flex-col sm:flex-row sm:gap-4">
                  <mat-form-field appearance="outline" class="flex-auto">
                    <mat-label [style.font-family]="'var(--vex-font)'">Contact</mat-label>
                    <input matInput type="number" placeholder="Contact Person's Contact" formControlName="contact"
                           (keyup)="registerFormStatus()" [style.font-family]="'var(--vex-font)'" numbersOnly>
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="flex-auto">
                    <mat-label [style.font-family]="'var(--vex-font)'">Username</mat-label>
                    <input matInput placeholder="Contact Person's Username" formControlName="username" maxlength="12"
                           [autocomplete]="false" (keyup)="registerFormStatus()" [style.font-family]="'var(--vex-font)'">
                  </mat-form-field>
                </div>
                <div class="flex flex-col sm:flex-row sm:gap-4">
                  <mat-form-field appearance="outline" class="flex-auto">
                    <mat-label [style.font-family]="'var(--vex-font)'">Password</mat-label>
                    <input matInput type="password" placeholder="Create Password" formControlName="password"
                           (keyup)="registerFormStatus()" [style.font-family]="'var(--vex-font)'">
                  </mat-form-field>
                  <mat-form-field appearance="outline" class="flex-auto">
                    <mat-label [style.font-family]="'var(--vex-font)'">Confirm Password</mat-label>
                    <input matInput type="password" placeholder="Confirm Password" formControlName="confirm_password"
                           [autocomplete]="false" (keyup)="registerFormStatus()" [style.font-family]="'var(--vex-font)'">
                  </mat-form-field>
                </div>
                <div class="flex items-center justify-center">
                  <mat-checkbox class="caption" formControlName="acceptTerms" (click)="keepChecked($event)"
                                [checked]="true"
                                [style.font-family]="'var(--vex-font)'">
                    I accept the <span class="text-blue-600"><a href="/terms-conditions" target="_blank"
                                                                [style.font-family]="'var(--vex-font)'">terms and conditions.</a></span>
                  </mat-checkbox>
                </div>
                <button type="button" (click)="signIn()"
                        [ngClass]="{ 'active': registerFormValid,'activeHover': registerFormValid, 'inactive': !registerFormValid }"
                        class="mt-20px" [style.font-family]="'var(--vex-font)'">
                  <ng-container *ngIf="submitted_loader; else normalText">
                    <i class="fa fa-spinner fa-spin mr-2"></i> Loading...
                  </ng-container>
                  <ng-template #normalText>
                    Register Organisation
                    <i class="fa fa-unlock font-extrabold ml-5"></i>
                  </ng-template>
                </button>
              </form>
            </mat-card-content>
          </mat-card>
        </div>
      </div>

    </div>
  </div>

  <div class="container bg-one my-10 rounded subheading-2" *ngIf="!status">
    <div class="flex flex-col md:flex-row p-6">
      <div class="p-2 md:p-6 w-full md:w-3/4">
        <p class="text-3xl py-6 font-bold text-gray-800">Check your phone for a 6-digit OTP</p>
        <p class="text-lg text-gray-600 mb-4">We've sent a 6-character code to your registered phone.</p>
        <form [formGroup]="otpForm" class="flex flex-wrap items-center">
          <div class="flex flex-row items-center justify-between w-full max-w-xs gap-2">
            <input type="text" class="otp-input w-16 h-16 text-lg text-center font-bold" maxlength="1"
                   formControlName="first_key" #otp1 (keyup)="moveFocus(otp1, otp2)">
            <input type="text" class="otp-input w-16 h-16 text-lg text-center font-bold" maxlength="1"
                   formControlName="second_key" #otp2 (keyup)="moveFocus(otp2, otp3)">
            <input type="text" class="otp-input w-16 h-16 text-lg text-center font-bold" maxlength="1"
                   formControlName="third_key" #otp3 (keyup)="moveFocus(otp3, otp4)">
            <input type="text" class="otp-input w-16 h-16 text-lg text-center font-bold" maxlength="1"
                   formControlName="fourth_key" #otp4 (keyup)="moveFocus(otp4, otp5)">
            <input type="text" class="otp-input w-16 h-16 text-lg text-center font-bold" maxlength="1"
                   formControlName="fifth_key" #otp5 (keyup)="moveFocus(otp5, otp6)">
            <input type="text" class="otp-input w-16 h-16 text-lg text-center font-bold" maxlength="1"
                   formControlName="sixth_key" #otp6 (keyup)="moveFocus(otp6, null)">
          </div>
        </form>
        <p class="text-gray-600 mb-4 lh-3rem">Didn't receive the OTP? <span class="text-red-500 cursor-pointer"
                                                                            (click)="otp()">Resend OTP</span>
        </p>
        <button class="py-2 px-4 w-1/2 bg-blue-700 text-white rounded-lg border-none hover:bg-blue-800"
                (click)="signIn()" [disabled]="submitted" *ngIf="!submitted_loader">
          <i class="fa fa-circle-check mr-3px"></i> {{ submitted ? 'Please Wait' : 'Verify' }}
        </button>
        <button class="py-2 px-4 w-1/2 bg-blue-700 text-white rounded-lg border-none hover:bg-blue-800 opacity-8 "
                [disabled]="submitted" *ngIf="submitted_loader" disabled>
          <i class="fa fa-spinner  mr-3px animate-spin"></i> {{ submitted ? 'Please Wait' : 'Verify' }}
        </button>
        <p class="text-sm text-zinc-500 pt-4 cursor-pointer" (click)="goBack()">
          <i class="fa-solid fa-arrow-left text-lg text-bold text-indigo-500"></i> Go Back
        </p>
      </div>
      <div class="w-full md:w-1/4 p-2 md:p-6 flex items-center justify-center">
        <img src="assets/images/OTP%201.png" alt="OTP" class="mx-auto mt-10 max-w-full h-auto">
      </div>
    </div>
  </div>


  <div class="container my-10">
    <div class="text-center py-10">
      <h2 class="text-4xl font-bold text-[#6752a9]">Why Choose ORBIT Office ERP?</h2>
      <p class="text-lg text-gray-700 mt-4">      Discover how ORBIT streamlines office operations, empowering your business with automation, security, and efficiency.
      </p>
    </div>
    <div class="flex flex-col md:flex-row justify-around items-center gap-8">
      <div class="max-w-sm text-center">
        <img src="assets/images/register-org/ease-of-use.svg" alt="Ease of Use" class="feature-img mx-auto mb-4">
        <h3 class="text-2xl font-semibold text-gray-800">Intuitive Dashboard</h3>
        <p class="text-gray-600">        A user-centric interface where teams can manage payroll, attendance, and communication seamlessly.
        </p>
      </div>
      <div class="max-w-sm text-center">
        <img src="assets/images/register-org/time-save.svg" alt="Time-Saving" class="feature-img mx-auto mb-4">
        <h3 class="text-2xl font-semibold text-gray-800">Smart Automation</h3>
        <p class="text-gray-600">        Automate workflows like approvals, reporting, and scheduling to save time and reduce manual errors.
        </p>
      </div>
      <div class="max-w-sm text-center">
        <img src="assets/images/register-org/secure.svg" alt="Security" class="feature-img mx-auto mb-4">
        <h3 class="text-2xl font-semibold text-gray-800">Secure Management</h3>
        <p class="text-gray-600">        Multi-layer data protection with role-based access and encryption, ensuring business-critical information stays safe.
        </p>
      </div>
    </div>
  </div>

  <div class="container my-10">
    <div class="text-center py-10">
      <h2 class="text-4xl font-bold text-[#6752a9]">What Our Clients Say</h2>
      <p class="text-lg text-gray-700 mt-4">      See how ORBIT has transformed office operations for leading organizations.
      </p>
    </div>
    <div class="flex flex-col md:flex-row justify-around items-center gap-8">
      <div class="max-w-md bg-white shadow-lg rounded-lg p-6">
        <p class="text-gray-600">        "With ORBIT, managing payroll and employee data has become effortless. Our operations are more transparent and efficient."
        </p>
        <p class="text-gray-800 font-semibold mt-4">- Ankit Mishra,<i
          class="fa fa-circle-check text-success ml-5 f-12px"></i> Verified </p>
      </div>
      <div class="max-w-md bg-white shadow-lg rounded-lg p-6">
        <p class="text-gray-600">        "The automation and real-time insights save us hours of work every week. ORBIT is a true game-changer for office ERP."
        </p>
        <p class="text-gray-800 font-semibold mt-4">- Deepak Raheja, <i
          class="fa fa-circle-check text-success ml-5 f-12px"></i> Verified</p>
      </div>
      <div class="max-w-md bg-white shadow-lg rounded-lg p-6">
        <p class="text-gray-600">        "Strong security and centralized management give us peace of mind. ORBIT keeps everything under control in one place."
        </p>
        <p class="text-gray-800 font-semibold mt-4">- Mohit Vij,<i
          class="fa fa-circle-check text-success ml-5 f-12px"> </i> Verified </p>
      </div>
    </div>
  </div>

  <div class="bg-[#6752a9] text-center text-white subheading-2 py-10">
    <h1>Streamline Your Office Operations with ORBIT ERP</h1>
    <h3 class="my-1">One platform for payroll, attendance, communication, and more.</h3>
    <!--  <button mat-button mat-raised-button class="border-2 my-4 btn-pulse"> Explore with a free trial - Get Register Now ! </button>-->
  </div>
</div>

<app-footer></app-footer>

